//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import WasteCollectItemDrawer from "./modules/WasteCollectItemDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { queryProjectArchtList } from '@/api/api';
export default {
  name: "WasteCollectItemList",
  mixins: [JeecgListMixin],
  components: {
    WasteCollectItemDrawer: WasteCollectItemDrawer
  },
  data: function data() {
    return {
      pagePath: '/om/waste/collect/item',
      pageTitle: '废液收集明细',
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: "center",
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'collectId',
        colName: 'collect_id',
        title: '收集id',
        align: "center",
        sorter: true
      }, {
        dataIndex: 'assetId',
        colName: 'asset_id',
        title: '设备资产ID',
        align: "center",
        sorter: true
      }, {
        dataIndex: 'quantity',
        colName: 'quantity',
        title: '废液量（L）',
        align: "center",
        sorter: true
      }, {
        dataIndex: 'remark',
        colName: 'remark',
        title: '备注',
        align: "center",
        sorter: true
      }, {
        title: '操作',
        dataIndex: 'action',
        align: "center",
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }]
    };
  },
  created: function created() {},
  computed: {},
  methods: {}
};